var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEmailIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.695
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 330",
    d: "M12.043 10.7a1.725 1.725 0 001.319-.688l9.548-9.4a3.13 3.13 0 00-2.208-.6H3.068a2.688 2.688 0 00-1.95.545l9.577 9.462a1.926 1.926 0 001.348.681zM.287 17.037l7.771-7.656-7.8-7.685A3.483 3.483 0 000 3.273v12.1a3.306 3.306 0 00.287 1.659zM3.326 18.7H20.96a2.609 2.609 0 001.921-.545l-7.885-7.771-.774.746a3.155 3.155 0 01-2.179 1.032 3.215 3.215 0 01-2.208-1.032l-.746-.746-7.914 7.771a3.182 3.182 0 002.151.545zm20.416-1.692A3.542 3.542 0 0024 15.402V3.3a3.423 3.423 0 00-.258-1.548l-7.771 7.627z",
    fill: "#fff"
  })));
}
export default SvgCheckEmailIos;